









import { Component, Vue } from "vue-property-decorator";
import Catalog from "@/components/blockbuster/Catalog.vue";
import Header from "@/components/Header.vue";
import metadata from "@/store/modules/metadata";

@Component({
  components: {
    Catalog,
    Header,
  },
})
export default class Home extends Vue {
  links = [
    { text: 'Portal', to: '/' },
    { text: 'Blockbuster', active: true },
  ];

  async mounted(): Promise<void> {
    await metadata.getMetadata();
  }

  async login(): Promise<void> {
    await this.$store.dispatch("authRequest");
  }
}
